export const EVENT_OPEN_CS_COMPENSATION_DIALOG = "open-cs-compensation-dialog";
export const EVENT_CLOSE_CS_COMPENSATION_DIALOG = "close-cs-compensation-dialog";
